<template>
  <div>
    <v-card color="grey lighten-3" light>
      <v-card-text>
        <v-timeline align-top dense>
          <v-timeline-item color="blue-grey">
            <template v-slot:icon>
              <v-icon small dark>mdi-file-document-outline</v-icon>
            </template>
            <!-- Muestra de datos del oficio depara -->
            
            <oficioDeparaTimelineComponent />
          </v-timeline-item>
          <!-- Termina la sección -->
        </v-timeline>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import oficioDeparaTimelineComponent from "./deparaTimeline.vue";

export default {
  name: "consultarDepara",
  components: {
    oficioDeparaTimelineComponent,
  },
  computed: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>